@if( getActiveTab() == TAB_REQUEST ) {
    <production-request-grid-component #tabRequest></production-request-grid-component>
}
